import { Box, InputLabel, Typography, FormControl, Select, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';

const SelectInput = ({
  label,
  sublabel = null,
  value,
  options,
  onChange,
  sx = {},
  placeholder = null,
  ...props
}) => {
  const placeholderProps = placeholder
    ? {
        displayEmpty: true,
        renderValue: (value) => {
          if (value === '') {
            return placeholder;
          }
          // `==` on next line is to support string-to-number comparison
          return options.find((option) => value == option.value)?.children;
        },
      }
    : {};
  return (
    <FormControl fullWidth>
      <Box>
        <InputLabel sx={{ position: 'relative', transform: 'unset', color: 'gray.700' }}>
          {typeof label === 'string' ? (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '1rem',
                lineHeight: '100%',
                letterSpacing: '0px',
              }}
            >
              {label}
            </Typography>
          ) : (
            label
          )}
        </InputLabel>
        {sublabel}
        <Box>
          <Select
            value={value}
            onChange={onChange}
            sx={{
              color: value === '' ? '#A2A2A2' : null,
              ...sx,
              borderRadius: '3px',
              margin: '9px 0',
            }}
            inputProps={{ sx: { padding: '5px 14px' } }}
            {...placeholderProps}
            {...props}
            fullWidth
          >
            {options.map(({ value: val, children }) => (
              <MenuItem key={val} value={val}>
                {children}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>
    </FormControl>
  );
};

SelectInput.displayName = 'SelectInput';

SelectInput.propTypes = {
  label: PropTypes.node,
  sublabel: PropTypes.node,
  value: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  sx: PropTypes.object,
};

export default SelectInput;
